import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "./components/Login";
import Header from "./components/Header";
import Home from "./components/Home";
import Detail from "./components/Detail";
import VideoPlayer from "./components/VideoPlayer";
import Anime from "./components/Anime";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Switch>
          <Route exact path="/">
            <Login />
          </Route>
          <Route path="/movies">
            <Home />
          </Route>
          <Route path="/detail/:id">
            <Detail />
          </Route>
          <Route path="/video">
            <VideoPlayer />
          </Route>
          <Route path="/home">
            <Anime />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;